import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csvariable(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
  
return(
    <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free JavaScript Variables Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript variables tutorial for beginners.variable in Javascript is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript variables,javascript variables,javascript variable declaration,javascript variable scope,javascript variable in string,javascript variable types,javascript is variable defined" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-variables" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Javascript Variables</h1>
    <div className="first">
       
        <a href="/javascript-keyword">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="pt-4 para ">
    1, Variable is the name of a memory location in which we can store the value <br/>
    2, Javascript can change the variable value<br/>
    3, A variable is defined by combining an identifier, data types, and an initializer.<br/>
4, The first character in the variable name must be an alphabet, underscore, a digit or,
a dollar sign. <br/>
5, All variables have a scope<br/>
6, The identifier is the name of the Variable<br/>
7, Commas or blanks are not using inside a variable name<br/>
8, Use dollar symbol($) before variable-name
    </p>




<h2 className="headings">
      Javascript variable declaration Syntax:
      </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}

            <span className="qwerty-4">Type </span>
            <span className="qwerty-3">Variable-Name; </span>
            {"\n"}
            <span className="qwerty-4">var </span>
            <span className="qwerty-5"> is a Type</span>
            {"\n"}
            <span className="qwerty-3">a</span>
            <span className="qwerty-8">,</span>
            <span className="qwerty-3">b </span>
            <span className="qwerty-8">and </span>
            <span className="qwerty-3">ab </span>
            <span className="qwerty-10">are a variable-name</span>
            {"\n"}
            

            {"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">
    Javascript Variable declaration Syntax Examples:
    </h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}

          <span className="qwerty-4">Type </span>
          <span className="qwerty-3">Variable-Name; </span>
          {"\n"}
          <span className="qwerty-4">var</span>
          <span className="qwerty-3"> roll_no;</span>
          <span className="qwerty-10">{` //this declare a variable `}</span>
          {"\n"}
          <span className="qwerty-4">var</span>
          <span className="qwerty-3"> percentage;</span>
          <span className="qwerty-5">{` //this declare a variable `}</span>
          {"\n"}
          <span className="qwerty-4">var</span>
          <span className="qwerty-3"> roll_no</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">40; </span>
          <span className="qwerty-10">{` //assigns a variable a value`}</span>
          {"\n"}
          <span className="qwerty-4">var</span>
          <span className="qwerty-3"> precentege</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">40.80; </span>
          <span className="qwerty-5">{` //assigns a variable a value`}</span>
          {"\n"}
          

          {"\n"}
        </code>
      </pre>
    </div>


<h2 className="mt-4 mh2">Declare a variable in Javascript:</h2>
<p className="para mt-3">These Variable declare in various types.</p>




    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}

          <span className="qwerty-4">var</span>
          <span className="qwerty-3"> abc;</span>
          <span className="qwerty-5">{` //this declare a variable `}</span>
          {"\n"}
          <span className="qwerty-4">var</span>
          <span className="qwerty-3"> a_bc;</span>
          <span className="qwerty-5">{` // (abc and a_bc are a variable) `}</span>
          {"\n"}
          <span className="qwerty-4">var</span>
          <span className="qwerty-3"> a;</span>
          <span className="qwerty-3"> b;</span>
          <span className="qwerty-3"> x;</span>
          <span className="qwerty-3"> z;</span>
          <span className="qwerty-5">{` //(a,b,x,z) are a variable`}</span>
          {"\n"}
          <span className="qwerty-4">var</span>
          <span className="qwerty-3"> a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">"Ram"; </span>
          <span className="qwerty-5">{` //a variable gain value ( Ram )`}</span>
          {"\n"}
          

          {"\n"}
        </code>
      </pre>
    </div>


<h2 className="mt-4 mh2">Q-Addition of Variables examples in JavaScript?</h2>



    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-3">&#60;</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">ab</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">20;</span>
          <span className="qwerty-3">cd</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">24;</span>
          <span className="qwerty-3">ef</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">36;</span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;document</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">write</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">ab</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4">cd</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4">ef</span>
          <span className="qwerty-1">);</span>
          {"\n"}

          <span className="qwerty-3">&#60;/</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}
        </code>
      </pre>
    </div>

    <div>
      <h3 className="headings">Output</h3>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">&nbsp;80 </span>
            {"\n"}
          </code>
          {"   "}
        </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">Q-Variable increment values in two times in Javascript?
</h2>

    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-3">&#60;</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">10;</span>
          <span className="qwerty-5">{`//a is a variable and a is a variable`}</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;a</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">40;</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-1">20;</span>
          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;document</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">write</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">);</span>
          {"\n"}

          <span className="qwerty-3">&#60;/</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}
        </code>
      </pre>
    </div>

    <div>
      <h3 className="headings">Output</h3>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">&nbsp;70 </span>
            {"\n"}
          </code>
          {"   "}
        </pre>
      </div>
    </div>




<h2 className="headings">
    Q-Create a variable and store a no inside this variable and print output?
    </h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-3">&#60;</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">40;</span>
          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;document</span>
          <span className="qwerty-5">.</span>
          <span className="qwerty-10">write</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">);</span>
          {"\n"}

          <span className="qwerty-3">&#60;/</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}
        </code>
      </pre>
    </div>

    <div>
      <h3 className="headings">Output</h3>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">&nbsp;40 </span>
            {"\n"}
          </code>
          {"   "}
        </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">Create Variable String Type: </h2>



<h2 className="headings">
    Q-Create a string Variable and store a no inside string type variable and print output?
    </h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-3">&#60;</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">,</span>
          <span className="qwerty-3">b;</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">"Ram"</span>
          {"\n"}
         
          <span className="qwerty-3">&nbsp;&nbsp;b</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">"Lakshman"</span>
          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;document</span>
          <span className="qwerty-5">.</span>
          <span className="qwerty-10">write</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-1">" "</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4">b</span>
          <span className="qwerty-1">);</span>
          {"\n"}

          <span className="qwerty-3">&#60;/</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}
        </code>
      </pre>
    </div>

    <div>
      <h3 className="headings">Output</h3>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">&nbsp;Ram </span>
            <span className="qwerty-5">Lakshman </span>
            {"\n"}
          </code>
          {"   "}
        </pre>
      </div>
    </div>


<h2 className="mt-4 mh2"> Another string type example</h2>



<h2 className="headings">
    Q-Create a string Variable and store a no inside string data type variable and print output?
    </h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-3">&#60;</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">a</span>
          <span className="qwerty-8">,</span>
          <span className="qwerty-3">b</span>
          <span className="qwerty-8">,</span>
          <span className="qwerty-3">c;</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;a</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">"Ram"</span>
          {"\n"}
         
          <span className="qwerty-3">&nbsp;&nbsp;b</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">"Lakshman"</span>
          {"\n"}

          <span className="qwerty-3">&nbsp;&nbsp;b</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-1">"My Name is CodeExampler 160208"</span>
          {"\n"}
          <span className="qwerty-10">&nbsp;&nbsp;document</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">write</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-1">" "</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4">b</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-1">" "</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4">c</span>
          <span className="qwerty-1">);</span>
          {"\n"}

          <span className="qwerty-3">&#60;/</span>
          <span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          {"\n"}
        </code>
      </pre>
    </div>

    <div>
      <h3 className="headings">Output</h3>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code className="python hljs">
            {"\n"}
            <span className="qwerty-3">&nbsp;Ram </span>
            <span className="qwerty-5">Lakshman </span>
            <span className="qwerty-8">My Name is CodeExampler 160208 </span>
            {"\n"}
          </code>
          {"   "}
        </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">Constant:</h2>

<p className="para mt-4">Constant use when you store a value inside a variable but use constant after you can’t overwrite the existing deal.
</p>


  <h1 className="mt-5">  </h1>
      <h1 className="mt-5">  </h1>
     
      <div className="back">
       
        <a href="/javascript-keyword">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csvariable;